import { z } from 'zod';
import type { TranslateFn } from '@/core/i18n/use-intl';

export const createOperationCreateSchema = (t: TranslateFn) =>
  z.object({
    title: z.string().min(1, t('validation.required')),
    description: z.string().optional(),
    customer: z.string().min(1, t('validation.required')),
    responsibleGmnUser: z.string().min(1, t('validation.required')),
    assignedCustomerUser: z.string().min(1, t('validation.required')),
    heliProviderUsers: z.array(z.string()).optional(),
    dispatcherUsers: z.array(z.string()).optional(),
    reportFile: z
      .instanceof(File, { message: t('operations.validation.reportFileRequired') })
      .refine(
        (file) => file.type === 'application/pdf' || file.name.toLowerCase().endsWith('.pdf'),
        {
          message: t('operations.validation.reportFileMustBePdf'),
        }
      ),
  });

export type OperationCreateFormData = z.infer<ReturnType<typeof createOperationCreateSchema>>;
